import axiosInstance from 'api/axiosInstance';

export const dismissAllOverstays = async (
	ticketNumbers: string[],
	dismissedByUserId: number,
): Promise<void> => {
	if (!ticketNumbers || ticketNumbers.length === 0) return;
	await axiosInstance.post(
		`/api2.0/overstays/dismissAll`,
		{ ticketNumbers, dismissedByUserId },
		{ headers: { 'Content-Type': 'application/json' } },
	);
};
